import exame from '@/router/parametrizacao/exame'
import kitExame from '@/router/parametrizacao/kitExame'
import procedimento from '@/router/parametrizacao/procedimento'
import procedimentoCirurgico from '@/router/parametrizacao/procedimentoCirurgico'
import relatorioExameCadastrado from '@/router/parametrizacao/relatorioExameCadastrado'
import tabelaCid from '@/router/parametrizacao/tabelaCid'
import tabelaObm from '@/router/parametrizacao/tabelaObm'

export default [
    {
        path: 'parametrizacao',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...exame,
            ...kitExame,
            ...procedimento,
            ...procedimentoCirurgico,
            ...relatorioExameCadastrado,
            ...tabelaCid,
            ...tabelaObm,
        ]
    }
]